module.exports = fox._r("images/press/materials-icon-vd.png", __webpack_public_path__ + "_/common/images/press/materials-icon-vd.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/materials-icon-vd.png
// module id = 370
// module chunks = 2